<template>
  <div class="d-inline ai">
    <img src="/ats_chat.png" alt="AI" class="chatToggler" @click="toggleChat" />
    <div class="container">
      <div class="chat-container vanish" id="chat">
        <div class="head">
          <img src="/ats_chat.png" alt="AI" />
          <h2 class="akkurate-green">FAQ ChatBot</h2>
        </div>

        <div class="chat-box akkurate-dark-gradient">
          <MessageBubble
            v-for="(message, id) in messages"
            :key="id"
            :msg="{ ...message }"
          />

          <!-- <div v-if="loading" class="bubble bot" id="thinking" ref="thinking">
            {{ loadingText }}
          </div> -->

          <MessageBubble
          v-if="loading"
            :msg="{ sender: 'bot', text: loadingText }"
          />
        </div>

        <div class="input">
          <input
            v-model="question"
            placeholder="Ask a question..."
            @keyup.enter="send"
          />
          <button @click="send" class="btn sendBtn akkurate-green-btn">
            <FontAwesomeIcon icon="paper-plane" class="plane" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { askQuestion } from "@/core/services/ai.service";
import MessageBubble from "./MessageBubble.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const question = ref("");
const loading = ref(false);

const loadingText = ref("");
const messages = ref([]);


import { nextTick } from "vue";

const scrollToBottom = () => {
  nextTick(() => {
    const chatBox = document.querySelector(".chat-box");
    chatBox.scrollTop = chatBox.scrollHeight;
  });
};


const send = async () => {
  let questionText = question.value;
  question.value = "";

  if (!questionText) return;
  messages.value.push({
    sender: "user",
    text: questionText,
  });

  loading.value = true;

  const tText = ["Thinking", "Thinking.", "Thinking..", "Thinking..."];
  let i = 0;

  let interval = 0;

  loadingText.value = tText[i];
  interval = setInterval(() => {
    i++;
    loadingText.value = tText[i % tText.length];

    scrollToBottom();
  }, 400);

  try {
    const res = await askQuestion(questionText);

    console.log("Tess: ",res);
    messages.value.push({
      sender: "bot",
      text: res.data.answer,
      score: 1,
    });
  } catch(err){
    messages.value.push({
      sender: "bot",
      text: "Something went wrong.",
    });

    console.warn(err)
  } finally {
    clearInterval(interval);
    i = 0;
    loading.value = false;
    scrollToBottom();
  }
};

const toggleChat = () => {
  document.getElementById("chat").classList.toggle("vanish");
};
</script>

<style scoped>
  .ai {
      position: fixed;
    bottom: 1rem;
    width: 2.75rem;
    height: 2.75rem;
    text-align: center;
    line-height: 24px;
    right: 80px; 
    z-index: 50;
    display: flex;
    align-items: center;
    border-radius: 50%;
    justify-content: center;
  }

.chat-container {
  background-color: #fff;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  display: flex;
  flex-direction: column;
  width: 300px;
  margin: 50px auto;
  padding: 0.5rem;
  border-radius: 20px;
  z-index: 20;
  gap: 5px;
}

.head {
  display: flex;
  align-items: center;
  gap: 5px;
}

.head img {
  width: 40px;
}

.head h2{
  font-weight: bold;
  font-size: 18px;
  padding: 0;
  margin: 0;
}

.input {
  display: flex;
  align-items: center;
  gap: 5px;
}

.input input {
  flex-grow: 1;
  padding: 0.25rem 0.5rem;
  border-radius: 10px;
  background-color: #eaeaea;
  color: black;
}

.chat-box {
  /* border: 1px solid #ccc; */
  border-radius: 10px;
  padding: 10px;
  height: 200px;
  overflow-y: auto;
}

.bubble {
  padding: 4px;
  margin: 4px 0;
  max-width: 80%;
  line-height: 1rem !important;
  text-align: left !important;
  border-radius: 10px;
  color: black;
}

.user {
  background: #4caf50;
  color: white;
  margin-left: auto;
}

.bot {
  background: #eee;
}

.ai .container {
  position: relative;
}

.vanish {
  display: none;
}

.chatToggler {
  width: 95%;
  cursor: pointer;
  transform: scale(1);

  transition: transform 0.3s ease-in-out;
}

.chatToggler:hover {
  transform: scale(1.1);
}

.chat-container {
  position: absolute;
  right: 0;
  bottom: 0;
}

.sendBtn {
  border-radius: 50% !important;
  cursor: pointer;
  color: #fff !important;
}
/* .sendBtn .plane {
  width: 25px;
  height: 25px;
  transform: rotate(35deg);
  color: white;
} */

.bubble .p{
  margin: 0 !important;
  padding: 0 !important;
}
</style>
